import Imm from '../support/ImmutableHelpers';
import DataStore from '../support/DataStore';

import { VendorSale, VendorNote } from '../types/shared/MarketSales';
import { fixMarketNotes } from './fixMarketNotes';

let dataStore = DataStore.getInstance('app');

let SaleActions = {
  updateVendorSale: (params: {
    marketID: string;
    date: string;
    vendorID: string;
    categoryID: string;
    sale: VendorSale | null;
    note: VendorNote | null;
  }) => {
    const { marketID, date, vendorID, categoryID, sale, note } = params;
    let paymentAndSalesByMarket = dataStore.get('sales');

    if (
      !paymentAndSalesByMarket ||
      !categoryID ||
      (!sale && !note && sale !== 0 && note !== '')
    ) {
      return;
    }

    let newPaymentAndSalesByMarket = Imm.setProperty(
      paymentAndSalesByMarket,
      marketID,
      (paymentAndSales) => {
        if (sale || sale === 0) {
          paymentAndSales = Imm.setProperty(
            paymentAndSales || {},
            'sales',
            (salesByDate) => {
              return Imm.setProperty(
                salesByDate || {},
                date,
                (salesByVendor) => {
                  return Imm.setProperty(
                    salesByVendor || {},
                    vendorID,
                    (salesByPayment) => {
                      return Imm.setProperty(
                        salesByPayment || {},
                        categoryID,
                        sale,
                      );
                    },
                  );
                },
              );
            },
          );
        }
        if (note) {
          paymentAndSales = Imm.setProperty(
            paymentAndSales || {},
            'notes',
            (notesByDate) => {
              return Imm.setProperty(
                fixMarketNotes(notesByDate),
                date,
                (notesByVendor) => {
                  return Imm.setProperty(
                    notesByVendor || {},
                    vendorID,
                    (notesByNoteId) => {
                      return Imm.setProperty(
                        notesByNoteId || {},
                        categoryID,
                        note,
                      );
                    },
                  );
                },
              );
            },
          );
        }
        return paymentAndSales;
      },
    );
    dataStore.set('sales', newPaymentAndSalesByMarket);
  },
};

export default SaleActions;
